export default [
    //FOR BRANCH USER==========================================================================
    {
        key: "newContractPr",
        status: "New PR",
        label: "This PR is not Subbmited Yet",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updateContractPrStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Submitted HOD",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "Why Are you Rejecting this PR?",

                buttonLabel: "Submit To HOD",
                color: 'success',
                icon: "icon-send",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to submit this to your HOD?",
                successMessage: "This PR has been successfully Submitted to HOD",

                sucessEventName: "changeView",
                successEventValue: "list",
            },

        ]

    },
    {
        key: "userApprovedPR",
        status: "Submitted PR Team",
        label: "This PR has been Approved by your HOD",
        reject_reason: "",
        actionButtons: [

        ]

    },
    {
        key: "Submitted HOD",
        status: "Submitted HOD",
        label: "This PR is waiting for Approval by your HOD",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "PO Generated",
        status: "PO Generated",
        label: "This PR has been Approved by HOD. PO is also generated and approved.",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "Rejected PR",
        status: "Rejected PR",
        label: "This PR was rejected by your HOD",
        reject_reason: "",
        actionButtons: [

        ]
    },


    //----------------------------------------------------------------------------------------------
    //FOR HOD==========================================================================

    {
        key: "HOD Pending Contract",
        status: "Submitted HOD",
        label: "Evaluate this PR and Approve or Reject it.",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updateContractPrStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "PO Generated",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Approve & Create PO",
                color: 'success',
                icon: "icon-thumbs-up",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this PR?",
                successMessage: "This PR has been successfully Approved & PO is generated and Approved.",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
            {
                endPoint: "updateContractPrStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Rejected by HOD",
                },

                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Reject Confirmation",
                rejectReasonMessage: "Why Are you Rejecting this PR?",

                buttonLabel: "Reject this PR",
                color: 'danger',
                icon: "icon-thumbs-down",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "",
                successMessage: "This PR has been successfully Rejected",

                sucessEventName: "changeView",
                successEventValue: "list",
            }
        ]
    },
    {
        key: "HOD Approved Contract",
        status: "PO Generated",
        label: "PR and PO is approved",
        reject_reason: "",
        actionButtons: [ 
        ]
    },
    
   
    //----------------------------------------------------------------------------------------------

    
]